import { useEffect, useRef } from "react";

/**
 * useGtmScrollTracker
 * Tracks when a component scrolls into view and sends a GTM event.
 *
 * @param {string} sectionName - The name of the section/component
 * @param {number} [threshold=0.4] - How much of the component must be visible before triggering
 */
export default function useGtmScrollTracker(sectionName, threshold = 0.4) {
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: "section_scroll",
            section_name: sectionName,
            timestamp: new Date().toISOString(),
          });
          console.log(`GTM Event Sent: ${sectionName} Scroll`);
        }
      },
      { threshold }
    );

    if (ref.current) observer.observe(ref.current);

    return () => {
      if (ref.current) observer.unobserve(ref.current);
    };
  }, [sectionName, threshold]);

  return ref;
}
